import Helmet from "react-helmet";
import headersList from "Constants/headersList";
import { Drawer } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import MenuListComponent from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { CheckActionPermission } from "Actions/commonAction";
import settingsIcon from "Assets/newicons/user-interface/setting-option/outline/setting-option-outline-16px.svg";
import RatingScale from "Module/Subscription/ConfigMode/Perform/360DegreeReview/RatingScale/index";
import { instance } from "Actions/AxiosInstance";
import reviewFormConcept from "Assets/Images/career_progress.svg";
import starIcon from "Assets/newicons/notify/star/glyph/star-glyph-16-px-yellow.svg";
import DynamicForm from "Component/DynamicForm";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import DrawerHeader from "Component/Headers/drawerHeader";
import PageHeader from "Component/Headers/pageHeader";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { IntlProvider } from "react-intl";
import get from "lodash/get";
import { connect } from "react-redux";
import { GetMasterData } from "Actions/MasterCodeAction";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import SearchSq from "Component/Material-ui/SearchSq";
import DefaultComp from "Component/DefaultComp/Defaultstatecomp";
import emp360 from "Assets/Svg/emp360.svg";
import CustomLoader from "Component/CustomLoader";

import {
  CreateComp,
  List,
  TDTypeConsts,
} from "../../../../business-configration/commons";
import Create from "./create";

let CALLAPI = true;
class ReviewForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: null,
      permissions: { editable: true, readonly: true },
      permissions1: { editable: false, readonly: true },
      listdata: [],
      data: false,
      createmenu: false,
      ratingscaleopen: false,
      value: 0,
      offset: 0,
      limit: 20,
      totalcount: 1,
      create_anchorEl: null,
      selectedRow: null,
      selectedData: null,
      allratings: [],
      participents: [],
      selectedParticipant: null,
      open: false,
      WeightageType: [],
      threecodes: [],
      fourcodes: [],
      fivecodes: [],
      isratingscaledata: false,
      backuplistdata: [],
      orderBy: "",
      order: "asc",
      searchFormValue: null,
      participanttypeid: null,
      headers: [
        {
          key: "formtitle",
          name: "Form name",
          type: TDTypeConsts.EXPENSE_POLICY_NAME,
          style: { textAlign: "left" },
        },
        {
          key: "reviewperiodtypename",
          name: "Review period",
          type: TDTypeConsts.OTHERS,
        },
        {
          key: "assignment",
          name: "Assigned to",
          type: TDTypeConsts.ASSIGNED_USER,
        },
        {
          key: "moreoptions",
          type: TDTypeConsts.MORE_OPTIONS,
        },
      ],
    };

    this.getList = this.getList.bind(this);
    this.renderList = this.renderList.bind(this);
    this.onCreate = this.onCreate.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.create = this.create.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onView = this.onView.bind(this);
    this.getDupilicate = this.getDupilicate.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.openRatingScale = this.openRatingScale.bind(this);
    this.onArchieve = this.onArchieve.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.onMoreOptionClick = this.onMoreOptionClick.bind(this);
    this.getReviewformdata = this.getReviewformdata.bind(this);
  }

  componentWillMount() {
    if (this.props.history.location.pathname.includes("create")) {
      this.props.history.push(`${this.props.match.path}/list`);
    }
  }

  async componentDidMount() {
    const WeightageType = await GetMasterData("WeightageType");
    const [isTrue, permissions] = CheckActionPermission("reviewform");
    if (isTrue) {
      this.setState({ permissions }, () => {
        window.addEventListener("scroll", this.handleScroll);
        this.getRatingScale();

        this.setState({
          WeightageType: WeightageType.data.result,
        });
        if (!this.state.permissions.editable) {
          const index = this.state.headers.findIndex(
            (x) => x.type == TDTypeConsts.MORE_OPTIONS,
          );
          if (index != -1) {
            this.state.headers.splice(index, 1);
          }
        }
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  openRatingScale() {
    this.setState({
      ratingscaleopen: true,
    });
  }

  handleScroll() {
  
    const windowBottom =
      Math.floor(window.innerHeight * 0.65) + window.pageYOffset;
    if (windowBottom + 50 >= Math.floor(window.innerHeight * 0.65)) {
      this.getList();
    }
  }

  getRatingScale() {
    this.setState({isLoading:true},  () => {

   
    instance
      .get(`perform/getratingscale`)
      .then((result) => {
        if (result.data.result.length > 0) {
          const ratings = [
            result.data.result.find((x) => x.ratingscaletypeid == 1),
            result.data.result.find((x) => x.ratingscaletypeid == 2),
            result.data.result.find((x) => x.ratingscaletypeid == 3),
            result.data.result.find((x) => x.ratingscaletypeid == 4),
            result.data.result.find((x) => x.ratingscaletypeid == 5),
          ];
          const threecodes = [];
          const fourcodes = [];
          const fivecodes = [];
          const threepoint = result.data.result.find(
            (rate) => rate.ratingscaletypeid == 1,
          );
          threepoint &&
            Object.keys(threepoint).forEach((key) => {
              if (
                key == "oneunicode" ||
                key == "twounicode" ||
                key == "threeunicode"
              ) {
                threecodes.push(threepoint[key]);
              }
            });
          const fourpoint = result.data.result.find(
            (rate) => rate.ratingscaletypeid == 2,
          );
          fourpoint &&
            Object.keys(fourpoint).forEach((key) => {
              if (
                key == "oneunicode" ||
                key == "twounicode" ||
                key == "threeunicode" ||
                key == "fourunicode"
              ) {
                fourcodes.push(fourpoint[key]);
              }
            });
          const fivepoint = result.data.result.find(
            (rate) => rate.ratingscaletypeid == 3,
          );
          fivepoint &&
            Object.keys(fivepoint).forEach((key) => {
              if (
                key == "oneunicode" ||
                key == "twounicode" ||
                key == "threeunicode" ||
                key == "fourunicode" ||
                key == "fiveunicode"
              ) {
                fivecodes.push(fivepoint[key]);
              }
            });
          this.setState(
            {
              allratings: ratings,
              threecodes,
              fourcodes,
              fivecodes,
              isratingscaledata: true,
            
            },
            this.getList(),
          );
        } else {
          // this.props.enqueueSnackbar("Please config rating scale first", {
          //   variant: "error",
          // });
          this.setState({ isratingscaledata: false }, this.getList());
        }
      })
      .catch((error) => {
        this.setState({isLoading:false})
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
    })
  }

  getList(isPageRefresh = false) {
    const { totalcount, offset, listdata, limit, value } = this.state;
    if (CALLAPI) {
      if (totalcount && offset < totalcount) {
        CALLAPI = false;
        this.setState({isLoading:true}, () => {

       
        instance
          .post(`perform/allreviewform`, {
            isdraft: value == 1 ? true : false,
            isarchived: value == 2 ? true : false,
            offset,
            limit,
          })
          .then((result) => {
            CALLAPI = true;
            let ListData = [];
            result.data.result.length > 0
              ? isPageRefresh == false
                ? (ListData = [...listdata, ...result.data.result])
                : (ListData = result.data.result)
              : (ListData = listdata);
              const noFormsData = result.data.result.length > 0 ? false : true;
            this.setState({
              isLoading: false,
              offset: offset + this.state.limit,
              totalcount: ListData[0] ? ListData[0].fullcount : 1,
              listdata: ListData.map((form) => ({
                ...form,
                isarchived: value == 2 ? true : false,
                reviewperiodtypename:
                  form.reviewtypeid == 1
                    ? form.reviewperiodtypename
                    : form.reviewtypeid == 2
                    ? "Manually"
                    : "Auto-triggered",
              })),
              backuplistdata: ListData.map((form) => ({
                ...form,
                isarchived: value == 2 ? true : false,
                reviewperiodtypename:
                  form.reviewtypeid == 1
                    ? form.reviewperiodtypename
                    : form.reviewtypeid == 2
                    ? "Manually"
                    : "Auto-triggered",
              })),
              data: true,
              noFormsData: noFormsData
            });
          })
          .catch((error) => {
            this.setState({ listdata: [], data: true, isLoading:false });
            const msg =
              error.response &&
              error.response.data &&
              error.response.data.error.message;
            this.props.enqueueSnackbar(msg, {
              variant: "error",
            });
          });
        })

      }
    }
  }

  onMoreOptionClick(event, row) {
    this.setState({
      createmenu: !this.state.createmenu,
      create_anchorEl: event.currentTarget,
      selectedRow: row,
    });
  }

  create() {
    return <Create {...this.props} {...this.state} onCancel={this.onCancel} />;
  }

  onCreate() {
    const obj = {
      focusareaid: null,
      focusareaname: "Focus area 1",
      competencyid: null,
      reviewquestion: [],
    };
    const area = [];

    area.push(obj);
    const selectedData = {
      reviewformid: null,
      formtitle: null,
      reviewstructureid: null,
      isdraft: true,
      length: 2,
      formfor: {
        reviewformforid: null,
        fortypeid: null,
        forids: null,
      },
      section: [
        {
          reviewsectionid: null,
          sectionname: "Result",
          weightagetypeid: null,
          focusarea: area,
        },
        {
          reviewsectionid: null,
          sectionname: "Behaviour",
          weightagetypeid: null,
          focusarea: area,
        },
      ],
    };
    this.setState(
      {
        selectedData,
        createmenu: false,
      },
      () => {
        if (this.state.isratingscaledata) {
          this.props.history.push(`${this.props.match.path}/create`);
        } else {
          this.props.enqueueSnackbar("Please config rating scale first", {
            variant: "error",
          });
        }
      },
    );
    console.log("area: ", area);
  }

  onEdit() {
    const { selectedRow } = this.state;
    instance
      .get(`perform/reviewform/${selectedRow ? selectedRow.reviewformid : ""}`)
      .then((result1) => {
        const selectedData = result1.data.result[0];
        if (selectedData.section.length == 1) {
          selectedData.length = 1 ? 1 : 2;
        }
        selectedData.formfor = selectedData.formfor
          ? selectedData.formfor.forids
            ? {
                ...selectedData.formfor,
                forids: selectedData.formfor.forids.split(","),
              }
            : selectedData.formfor
          : null;
        selectedData.section = !selectedData.section
          ? [
              {
                reviewsectionid: null,
                sectionname: "Section A",
                weightagetypeid: null,
                focusarea: [],
              },
              {
                reviewsectionid: null,
                sectionname: "Section B",
                weightagetypeid: null,
                focusarea: [],
              },
            ]
          : selectedData.section.length == 1
          ? [
              ...selectedData.section,
              {
                reviewsectionid: null,
                sectionname: "Section B",
                weightagetypeid: null,
                focusarea: [],
              },
            ]
          : selectedData.section;
        console.log("selectedData: ", selectedData);
        this.setState({ selectedData, createmenu: false }, () => {
          this.props.history.push(`${this.props.match.path}/create`);
        });
      })
      .catch((error) => {
        // const msg = error.response && error.response.data && error.response.data.error.message;
        // this.props.enqueueSnackbar(msg || "", {
        //   variant: "error",
        // });
      });
  }

  onView() {
    const { selectedRow } = this.state;
    instance
      .get(`perform/reviewform/${selectedRow ? selectedRow.reviewformid : ""}`)
      .then(async (result1) => {
        const selectedData = result1.data.result[0];
        if (selectedData.section.length == 1) {
          selectedData.length = 1 ? 1 : 2;
        }
        selectedData.formfor = selectedData.formfor
          ? selectedData.formfor.forids
            ? {
                ...selectedData.formfor,
                forids: selectedData.formfor.forids.split(","),
              }
            : selectedData.formfor
          : null;
        selectedData.section = !selectedData.section
          ? [
              {
                reviewsectionid: null,
                sectionname: "Section A",
                weightagetypeid: null,
                focusarea: [],
              },
              {
                reviewsectionid: null,
                sectionname: "Section B",
                weightagetypeid: null,
                focusarea: [],
              },
            ]
          : selectedData.section;
        selectedData.section.length == 1 &&
          selectedData.section.push({
            reviewsectionid: null,
            sectionname: "Section B",
            weightagetypeid: null,
            focusarea: [],
          });
        const ParticipantType = await instance.get(
          `perform/reviewstructureparticipant/${
            selectedData && selectedData.reviewstructureid
          }`,
        );
        let participents = ParticipantType.data.result || [];
        participents = participents.map((part) => {
          const obj = part;
          obj.questions = [];
          selectedData.section.forEach((sec) => {
            sec.focusarea.forEach((focus) => {
              focus.reviewquestion.forEach((q) => {
                q.questionevaluation.forEach((qe) => {
                  if (part.displayvalue == qe.participanttypeid) {
                    obj.questions.push({
                      ...q,
                      focusareaname: focus.focusareaname,
                      sectionname: sec.sectionname,
                    });
                  }
                });
              });
            });
          });
          return obj;
        });
        this.setState({
          selectedRow: null,
          createmenu: false,
          open: true,
          participents,
          participanttypeid: participents[0] && participents[0].displayvalue,
          selectedParticipant: participents[0],
        });
      })
      .catch((error) => {
        // const msg = error.response && error.response.data && error.response.data.error.message;
        // this.props.enqueueSnackbar(msg || "", {
        //   variant: "error",
        // });
      });
  }

  getDupilicate() {
    const { selectedRow } = this.state;
    instance
      .get(`perform/reviewform/${selectedRow ? selectedRow.reviewformid : ""}`)
      .then((result1) => {
        const selectedData = result1.data.result[0];
        if (selectedData.section.length == 1) {
          selectedData.length = 1 ? 1 : 2;
        }
        selectedData.reviewformid = null;
        selectedData.formfor = selectedData.formfor
          ? selectedData.formfor.forids
            ? {
                ...selectedData.formfor,
                forids: selectedData.formfor.forids.split(","),
                reviewformforid: null,
              }
            : { ...selectedData.formfor, reviewformforid: null }
          : null;
        selectedData.section = !selectedData.section
          ? [
              {
                reviewsectionid: null,
                sectionname: "Section A",
                weightagetypeid: null,
                focusarea: [],
              },
              {
                reviewsectionid: null,
                sectionname: "Section B",
                weightagetypeid: null,
                focusarea: [],
              },
            ]
          : selectedData.section.map((sec) => ({
              ...sec,
              reviewsectionid: null,
              focusarea: sec.focusarea.map((f) => ({
                ...f,
                focusareaid: null,
                reviewquestion: f.reviewquestion.map((q) => ({
                  ...q,
                  reviewquestionid: null,
                  questionevaluation: q.questionevaluation.map((qe) => ({
                    ...qe,
                    questionevaluationid: null,
                  })),
                  questioninputoption: q.questioninputoption
                    ? q.questioninputoption.map((qe) => ({
                        ...qe,
                        questioninputoptionid: null,
                      }))
                    : null,
                })),
              })),
            }));
        selectedData.section.length == 1 &&
          selectedData.section.push({
            reviewsectionid: null,
            sectionname: "Section B",
            weightagetypeid: null,
            focusarea: [],
          });
        console.log("selectedData: ", selectedData);
        this.setState({ selectedData, createmenu: false }, () => {
          this.props.history.push(`${this.props.match.path}/create`);
        });
      })
      .catch((error) => {
        // const msg = error.response && error.response.data && error.response.data.error.message;
        // this.props.enqueueSnackbar(msg || "", {
        //   variant: "error",
        // });
      });
  }

  onDelete() {
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => {
            const { selectedRow } = this.state;
            this.props.closeSnackbar();
            instance
              .delete(
                `perform/deletereviewform/${
                  selectedRow ? selectedRow.reviewformid : ""
                }`,
              )
              .then(() => {
                this.props.enqueueSnackbar("Successfully deleted.", {
                  variant: "success",
                });
                this.setState(
                  {
                    selectedRow: null,
                    createmenu: false,
                    // listdata: [],
                    offset: 0,
                    totalcount: 1,
                  },
                  () => this.getList(true),
                );
              })
              .catch((error) => {
                const msg =
                  error.response &&
                  error.response.data &&
                  error.response.data.error.message;
                this.props.enqueueSnackbar(msg || "", {
                  variant: "error",
                });
              });
          }}
        >
          Yes
        </Button>,
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => this.props.closeSnackbar()}
        >
          No
        </Button>,
      ],
    });
  }

  getReviewformdata() {
    this.setState(
      {
        ratingscaleopen: false,
      },
      () => this.getRatingScale(),
    );
  }

  showLoader() {
    return (
      <div
        className="pre-loader"
        style={
          {
            // marginLeft: "50%",
            // transform: "translateX(-50%)"
          }
        }
      >
        <CustomLoader/>
      </div>
    );
  }

  onArchieve() {
    const { selectedRow } = this.state;
    instance
      .put(
        `perform/archivereviewform/${
          selectedRow ? selectedRow.reviewformid : ""
        }`,
      )
      .then(() => {
        this.props.enqueueSnackbar("Successfully archieved.", {
          variant: "success",
        });
        this.setState(
          {
            selectedRow: null,
            createmenu: false,
            // listdata: [],
            offset: 0,
            totalcount: 1,
          },
          () => {
            this.getList(true);
          },
        );
        this.props.closeSnakcbar();
      })
      .catch((error) => {
        // const msg = error.response && error.response.data && error.response.data.error.message;
        // this.props.enqueueSnackbar(msg || "", {
        //   variant: "error",
        // });
      });
  }

  onCancel(isdraft) {
    const obj = {
      focusareaid: null,
      focusareaname: "Focus area 1",
      competencyid: null,
      reviewquestion: [],
    };
    const area = [];
    area.push(obj);
    const selectedData = {
      reviewformid: null,
      formtitle: null,
      reviewstructureid: null,
      isdraft: true,
      formfor: {
        reviewformforid: null,
        fortypeid: null,
        forids: null,
      },
      section: [
        {
          reviewsectionid: null,
          sectionname: "Result",
          weightagetypeid: null,
          focusarea: area,
        },
        {
          reviewsectionid: null,
          sectionname: "Behaviour",
          weightagetypeid: null,
          focusarea: area,
        },
      ],
    };
    this.setState(
      {
        selectedData,
        // listdata: [],
        offset: 0,
        totalcount: 1,
        value: isdraft ? 1 : 0,
      },
      () => {
        this.getList(true);
        this.props.history.push(`${this.props.match.path}`);
      },
    );
  }

  stableSort(array = [], cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  getSorting(order, orderBy) {
    return order === "desc"
      ? (a, b) => this.desc(a, b, orderBy)
      : (a, b) => -this.desc(a, b, orderBy);
  }

  handleSort = (property) => {
    // console.log(property, event, 'onsort');
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }
    const listdata = this.stableSort(
      this.state.listdata,
      this.getSorting(order, orderBy),
    );
    this.setState({ order, orderBy, listdata });
  };

  handleFormSearch = (e) => {
    const { backuplistdata } = this.state;
    const filterFormList = backuplistdata.filter(
      (item) => item.formtitle.search(e.target.value) !== -1,
    );
    this.setState({
      searchFormValue: e.target.value,
      listdata: e.target.value ? filterFormList : backuplistdata,
    });
  };

  renderList() {
    const { value, listdata, selectedRow, headers, searchFormValue } =
      this.state;

    
    return (
      // this.state.data && (
        <div className="innerwrapper-full-width">
          <div className="common-menubar-header">
            <Tabs
              value={value}
              indicatorColor="#fff"
              textColor="primary"
              scrollButtons="auto"
            >
              <Tab
                label="Saved"
                className={`tabheading ${
                  value == 0 ? "active-tab1" : "inactive-tab1"
                } `}
                onClick={() =>
                  this.setState(
                    {
                      value: 0,
                      offset: 0,
                      listdata: [],
                      totalcount: 1,
                    //  isLoading: true,
                    },
                    () => this.getList(true),
                  )
                }
              />
              <Tab
                label="Drafts"
                className={`tabheading ${
                  value == 1 ? "active-tab1" : "inactive-tab1"
                } `}
                onClick={() =>
                  this.setState(
                    {
                      value: 1,
                      offset: 0,
                      listdata: [],
                      totalcount: 1,
                    //  isLoading: true,
                    },
                    () => {
                      this.getList(true);
                    },
                  )
                }
              />
              <Tab
                label="Archived"
                className={`tabheading ${
                  value == 2 ? "active-tab1" : "inactive-tab1"
                } `}
                onClick={() =>
                  this.setState(
                    {
                      value: 2,
                      offset: 0,
                      listdata: [],
                      totalcount: 1,
                    //  isLoading: true,
                    },
                    () => {
                      this.getList(true);
                    },
                  )
                }
              />
            </Tabs>
            <div className="tab-border"></div>
          </div>
          {
            <div className="content-outer-wrapper-with-tab">
              <Grid container>
                <Grid item xs={12} md={2} sm={2}>
                  <PageHeader header="Review form" />
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={10}
                  sm={2}
                  justify="flex-end"
                  className="display-flex"
                >
                  {(listdata.length > 0 || searchFormValue) && (
                    <span style={{ width: 240 }}>
                      <span
                        className="t-16"
                        style={{ color: "rgba(0,0,0,0.87)", marginRight: 4 }}
                      >
                        Sort By:
                      </span>
                      <Select
                        name="age"
                        displayEmpty
                        value={this.state.orderBy}
                        onChange={(e) => {
                          this.handleSort(e.target.value);
                        }}
                        className="text-color-grey select-sort width70"
                        variant="outlined"
                      >
                        <MenuItem className="sort-item" value={"sortableDate"}>
                          Created Date
                        </MenuItem>
                        {headers
                          .filter((x) => x.key != "edit" && x.key != "delete")
                          .map((header) => {
                            if (
                              header.key !== "addedbyimagepath" &&
                              header.key !== "assignedEmployeeList" &&
                              header.key !== "policydescription"
                            ) {
                              return (
                                <MenuItem value={header.key}>
                                  {get(header, "name", "-")}
                                </MenuItem>
                              ); // .props.defaultMessage
                            }
                            return null;
                          })}
                      </Select>
                    </span>
                  )}
                  {(listdata.length > 0 || searchFormValue) && (
                    <span className="margin-right-8" style={{ width: 250 }}>
                      <SearchSq
                        placeholder="Search employee by name"
                        value={this.state.searchFormValue}
                        onChange={(e) => this.handleFormSearch(e)}
                      />
                    </span>
                  )}
                  {this.state.value == 0 && (
                    <>
                      <span
                        className="rounded-rectangle-div margin-right-16"
                        style={{
                          padding: "8px 16px",
                          marginRight: 10,
                          width: 120,
                          display: "flex",
                          height: 22,
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                        onClick={this.openRatingScale}
                      >
                        <p className="small-dark-secondary margin-right-16">
                          Rating scale
                        </p>
                        <img src={settingsIcon}></img>
                      </span>
                      {this.state.permissions &&
                        this.state.permissions.editable &&
                        (listdata.length > 0 || searchFormValue) && (
                          <Button
                            variant="contained"
                            className="btn btn-primary-md-blue "
                            color="primary"
                            onClick={this.onCreate}
                          >
                            Create
                          </Button>
                        )}
                    </>
                  )}
                </Grid>
              </Grid>
            
            {this.state.noFormsData ? 
              <div>
              <CreateComp
                //text="text"
                // heading="Concept of Review form"
                heading="There are no review forms available"
                onCreate={this.onCreate}
                imageSrc={reviewFormConcept}
                permissions={this.state.value != 2 ? this.state.permissions : this.state.permissions1 }
              />
            </div>
          
              :  <div>
                  {listdata.length > 0 ? (
                    <div onScroll={this.handleScroll}>
                      <List
                        // onCreate={this.onCreate}
                        list={this.state.listdata}
                        headers={
                          this.state.value == 1
                            ? this.state.headers.filter(
                                (h) => h.key != "assignment",
                              )
                            : this.state.headers
                        }
                        permissions={this.state.permissions}
                        onEdit={this.onEdit}
                        onDelete={this.onDelete}
                        module="reviewform"
                        showOnlyList
                        onMoreOptionClick={(e, row) =>
                          this.onMoreOptionClick(e, row)
                        }
                      />
                    </div>
                  ) : searchFormValue && listdata.length == 0 ? (
                  
                    <div
                    style={{ height: "77vh" }}
                    className="position-rel margin-top-16"
                  >
                    <DefaultComp
                      //  text={this.getText()}
                      heading={"There are no review forms!"}
                      imageSrc={emp360}
                    />
                  </div>
                  ) : this.state.isLoading?  (
                    <div>
                   <CustomLoader/>
                  </div>
                  )
                  : 
                  // <CustomLoader/>
                  null
                  
                }
                </div>
}

{/* {this.state.noFormsData && listdata.length == 0 && !searchFormValue &&
                <div>
                    <CreateComp
                      //text="text"
                      // heading="Concept of Review form"
                      heading="There are no review forms available"
                      onCreate={this.onCreate}
                      imageSrc={reviewFormConcept}
                      permissions={this.state.value != 2 ? this.state.permissions : this.state.permissions1 }
                    />
                  </div>
            
          } */}
              <Popover
                open={this.state.createmenu}
                anchorEl={this.state.create_anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                onClose={() => this.setState({ createmenu: false })}
                className="margin-top-8"
              >
                <Paper style={{ width: 190 }}>
                  <div>
                    <MenuListComponent>
                      {((selectedRow && selectedRow.isdraft) ||
                        (selectedRow &&
                          !selectedRow.isdraft &&
                          selectedRow.iseditable)) && (
                        <ListItem
                          className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                          onClick={this.onEdit}
                        >
                          <ListItemText style={{ padding: 0 }}>
                            <span className="small-dark-secondary">Edit</span>
                          </ListItemText>
                        </ListItem>
                      )}
                      {selectedRow &&
                        !selectedRow.isdraft &&
                        !selectedRow.iseditable && (
                          <ListItem
                            className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                            onClick={this.onView}
                          >
                            <ListItemText style={{ padding: 0 }}>
                              <span className="small-dark-secondary">View</span>
                            </ListItemText>
                          </ListItem>
                        )}
                      {value == 0 && (
                        <ListItem
                          className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                          onClick={this.getDupilicate}
                        >
                          <ListItemText style={{ padding: 0 }}>
                            <span className="small-dark-secondary">
                              Duplicate{" "}
                            </span>
                          </ListItemText>
                        </ListItem>
                      )}

                      {selectedRow && selectedRow.iseditable && (
                        <ListItem
                          className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                          onClick={this.onDelete}
                        >
                          <ListItemText style={{ padding: 0 }}>
                            <span className="small-dark-secondary">Delete</span>
                          </ListItemText>
                        </ListItem>
                      )}
                      {selectedRow && !selectedRow.isarchived && (
                        <ListItem
                          className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                          onClick={this.onArchieve}
                        >
                          <ListItemText style={{ padding: 0 }}>
                            <span className="small-dark-secondary">
                              Archive
                            </span>
                          </ListItemText>
                        </ListItem>
                      )}
                    </MenuListComponent>
                  </div>
                </Paper>
              </Popover>
              <Drawer
                anchor="right"
                open={this.state.ratingscaleopen}
                onClose={() =>
                  this.setState({
                    ratingscaleopen: false,
                  })
                }
                classes={{
                  paper: "planner-drawer padding15 width40",
                }}
              >
                <DrawerHeader
                  header={"Rating scale"}
                  isbackarrow={false}
                  closeDrawer={() =>
                    this.setState({
                      ratingscaleopen: false,
                    })
                  }
                />
                <div>
                  <RatingScale getReviewformdata={this.getReviewformdata} />
                </div>
              </Drawer>
            </div>
          }
        </div>
      // )
    );
  }

  render() {
    const { match } = this.props;
    const {
      threecodes,
      fourcodes,
      fivecodes,
      participanttypeid,
      selectedParticipant,
      participents,
    } = this.state;
    const getCount = (id) => {
      if (id == 1) return 3;
      if (id == 2) return 4;
      if (id == 3) return 5;
      if (id == 4) return 7;
      if (id == 5) return 10;
    };

    const getCountForEmoji = (id) => {
      if (id == 1) return threecodes;
      if (id == 2) return fourcodes;
      if (id == 3) return fivecodes;
    };
    return (
      <div>
        <Helmet>
          <title>{headersList.Config.ReviewForm.header}</title>
        </Helmet>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <div>
            <IntlProvider locale="en">
              <div>
                {
                  <div>
                    <div>
                      <Switch>
                        <Route
                          exact
                          path={`${match.path}`}
                          render={this.renderList}
                        />
                        <Route
                          exact
                          path={`${match.path}/create`}
                          render={this.create}
                        />
                        <Redirect from={`${match.path}`} to={`${match.path}`} />
                      </Switch>
                    </div>
                  </div>
                }
              </div>
            </IntlProvider>
            <Drawer
              anchor="right"
              open={this.state.open}
              onClose={() =>
                this.setState({
                  open: false,
                  threecodes: [],
                  fourcodes: [],
                  fivecodes: [],
                  participents: [],
                  selectedRow: null,
                  participanttypeid: null,
                  selectedParticipant: null,
                })
              }
              classes={{
                paper: "planner-drawer padding15 width30",
              }}
            >
              <DrawerHeader
                header={"View form"}
                isbackarrow={false}
                closeDrawer={() =>
                  this.setState({
                    selectedRow: null,
                    open: false,
                    threecodes: [],
                    fourcodes: [],
                    fivecodes: [],
                    participents: [],
                    participanttypeid: null,
                    selectedParticipant: null,
                  })
                }
              />
              <div
                className="hide-div-scroll margin-bottom-24"
                style={{ height: "96vh", overflowY: "auto", paddingRight: 15 }}
              >
                <Grid container>
                  <Grid item md={12} sm={12}>
                    <div>
                      <DynamicForm
                        fields={selectinputconverter({
                          value: participanttypeid,
                          placeholder: "Select participant",
                          label: "View as",
                          options: participents,
                        })}
                        onChange={(value) => {
                          this.setState({
                            participanttypeid: value,
                            selectedParticipant: participents.find(
                              (p) => p.displayvalue == value,
                            ),
                          });
                        }}
                      />
                    </div>
                  </Grid>
                  {selectedParticipant &&
                    selectedParticipant.questions &&
                    selectedParticipant.questions.map((question, index) => (
                      <Grid
                        item
                        md={12}
                        sm={12}
                        className="margin-top-16 question-section"
                      >
                        <p className="extra-small-dark-disabled t-bold margin-bottom-4">
                          {question.sectionname}
                          {" / "}
                          {question.focusareaname}
                        </p>
                        <Paper className="rounded-rectangle-paper padding16">
                          <p className="small-dark margin-bottom-4">
                            {index + 1}
                            {". "}
                            {question.question}
                          </p>
                          <p className="small-dark input-label margin-bottom-8">
                            {question.description}
                          </p>
                          <p className="small-dark margin-bottom-8">
                            Weightage:{" "}
                            {
                              this.state.WeightageType.find(
                                (x) =>
                                  x.displayvalue == question.weightagetypeid,
                              ).displayname
                            }
                          </p>
                          <div>
                            {question.iscontributeinrating &&
                              question.ratingtypeid == 1 &&
                              getCount(question.ratingscaletypeid) &&
                              Array.from(
                                Array(getCount(question.ratingscaletypeid)),
                                (val, index1) => index1 + 1,
                              ).map((num) => (
                                <div className="floatleft">
                                  <div className="rating-scale-points-disabled">
                                    <span>{num}</span>
                                  </div>
                                  <div className="clear-float"></div>
                                </div>
                              ))}
                            {question.iscontributeinrating &&
                              question.ratingtypeid == 2 &&
                              getCount(question.ratingscaletypeid) &&
                              Array.from(
                                Array(getCount(question.ratingscaletypeid)),
                                (val, index1) => index1 + 1,
                              ).map(() => (
                                <div className="floatleft">
                                  <div className="rating-scale-points-disabled">
                                    <img
                                      style={{ width: 12 }}
                                      src={starIcon}
                                    ></img>
                                  </div>
                                  <div className="clear-float"></div>
                                </div>
                              ))}
                            {question.iscontributeinrating &&
                              question.ratingtypeid == 3 &&
                              getCountForEmoji(question.ratingscaletypeid) &&
                              getCountForEmoji(question.ratingscaletypeid).map(
                                (emoji) => (
                                  <div className="floatleft">
                                    <div className="rating-scale-points">
                                      {String.fromCodePoint(
                                        parseInt(emoji, 16),
                                      )}
                                    </div>
                                    <div className="clear-float"></div>
                                  </div>
                                ),
                              )}
                            {!question.iscontributeinrating &&
                              question.questioninputtypeid == 2 &&
                              question.questioninputoption &&
                              question.questioninputoption.map((op) => (
                                <div>
                                  <p className="small-dark-secondary margin-bottom-8">
                                    {op.optionname}
                                  </p>
                                </div>
                              ))}
                          </div>
                          <div className="clear-float"></div>
                        </Paper>
                      </Grid>
                    ))}
                </Grid>
              </div>
            </Drawer>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  SubscriptionInfo: state.SubscriptionInfo,
  loginData: state.AuthenticationAction.login,
  AuthenticationAction: state.AuthenticationAction,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withSnackbar(ReviewForm)),
);
